import { memo, useRef } from 'react';
import { useFileSelection, UseFileSelectionOptions } from '../hooks';
import { DEFAULT_ACCEPT } from '../media.constants';
import { useMedia } from '../media.context';
import { Button } from 'components/ui';
import { SVG } from 'components/svg';
import { Icons } from 'assets';

type MediaUploaderProps = Pick<
  UseFileSelectionOptions,
  'maxFileSize' | 'maxFiles' | 'validateFormat'
> & {
  accept?: string;
  multiple?: boolean;
  disabled?: boolean;
};

export const MediaUploader = memo((props: MediaUploaderProps) => {
  const {
    accept = DEFAULT_ACCEPT,
    multiple = true,
    disabled = false,
    ...useFileSelectionOptions
  } = props;
  const { dispatch } = useMedia();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = useFileSelection((files) => {
    dispatch({
      type: 'MEDIA/FILES_ADDED',
      files,
    });
  }, useFileSelectionOptions);

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={(e) => handleChange(e.target.files)}
        style={{ display: 'none' }}
      />

      <Button
        leftIcon={<SVG src={Icons.Plus} />}
        mode="neutral"
        variant="outline"
        size="s"
        onClick={() => inputRef.current?.click()}
        disabled={disabled}
      >
        Добавить файл
      </Button>
    </>
  );
});
